module.exports = __webpack_public_path__ + "img/icon-contact-02.a1969904.svg";